export enum UserNotificationModule {
  PurchaseOrder = 'purchase_orders',
  SalesOrder = 'sales_orders',
  Reference = 'references',
}
